'use client';

import type { TwoColumnConfig, ReceiptSettings } from '@/lib/templates/schema';
import { SectionDivider } from './SectionDivider';

interface TwoColumnSectionProps {
  config: TwoColumnConfig;
  settings: ReceiptSettings;
}

export function TwoColumnSection({ config, settings }: TwoColumnSectionProps) {
  const hasColumn2 = config.column2 && config.column2.length > 0;
  const isNarrow = settings.spacing === 'narrow';

  return (
    <div className={`receipt-section ${isNarrow ? 'py-0.5' : 'py-2'}`}>
      <div className={`flex ${isNarrow ? 'gap-2' : 'gap-4'}`}>
        {/* Column 1 */}
        <div 
          className={`${isNarrow ? '' : 'space-y-0.5'} ${hasColumn2 ? 'flex-1' : 'w-full'}`}
          style={{ lineHeight: isNarrow ? 1.15 : 1.4 }}
        >
          {config.column1.map((item) => (
            <div
              key={item.id}
              className="flex justify-between gap-2"
              style={{
                fontSize: settings.fontSize,
                fontFamily: settings.font,
              }}
            >
              <span className="shrink-0 whitespace-pre">{item.label}</span>
              <span className="text-right whitespace-pre">{item.value}</span>
            </div>
          ))}
        </div>

        {/* Column 2 */}
        {hasColumn2 && (
          <div 
            className={`flex-1 ${isNarrow ? '' : 'space-y-0.5'}`}
            style={{ lineHeight: isNarrow ? 1.15 : 1.4 }}
          >
            {config.column2.map((item) => (
              <div
                key={item.id}
                className="flex justify-between gap-2"
                style={{
                  fontSize: settings.fontSize,
                  fontFamily: settings.font,
                }}
              >
                <span className="shrink-0 whitespace-pre">{item.label}</span>
                <span className="text-right whitespace-pre">{item.value}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Divider */}
      {config.showDivider && (
        <SectionDivider style={config.dividerStyle} settings={settings} />
      )}
    </div>
  );
}

